import Cookies from "js-cookie";
var uuid = require("uuid");

// state
const state = () => ({
    user: [],
    user_id: [],
    currentUser: [],
    totalBalance: 0,
    tenant: [],
    getAccess: [],
    feature: [],
    app: [],
    report: [],
    app: [],
    package: "",
    planSerie: "",
    planGroup: "",
    menu: [],
    planTrial: [],
    planTrialPeriod: '',
    planTrialStartsAt: '',
    planTrialEndsAt: '',
    planTenantID: '',
    planLastPurchase: '',
    planAppMarketing: [],
    setting: {},
    merchantInfo: {},
    uuid: uuid.v4(),
    plan: [],
    getPlanActive: [],
    showPlanNoti: false,
    showExceed:false,
    currentAction: '',
    orderId: '',
    flatRates: [],
    setMenuWms: 0,
    unRead: '',
  });

  // getters
  const getters = {};

  // actions
  const actions = {
    getUser({ commit }, fields) {
      commit('getUser', fields);
    },
    getCurrentUser({ commit }, fields) {
      commit('getCurrentUser', fields);
    },
    updateTotalBalance({ commit }, data) {
      commit('updateTotalBalance', data);
    },
    getTenant({ commit }, data) {
      commit('getTenant', data);
    },
    getAccess({ commit }, data) {
      commit('getAccess', data);
    },
    getFeature({ commit }, fields) {
      commit('getFeature', fields);
    },
    getApp({ commit }, fields) {
      commit('getApp', fields);
    },
    getMenu({ commit }, fields) {
      commit('getMenu', fields);
    },
    getPackage({ commit }, fields) {
      commit('getPackage', fields);
    },
    getReport({ commit }, fields) {
      commit('getReport', fields);
    },
    getPlanSerie({ commit }, fields) {
      commit('getPlanSerie', fields);
    },
    getPlanGroup({ commit }, fields) {
      commit('getPlanGroup', fields);
    },
    getPlanTrial({ commit }, fields) {
      commit('getPlanTrial', fields);
    },
    getPlanTrialPeriod({ commit }, fields) {
      commit('getPlanTrialPeriod', fields);
    },
    getPlanTrialStartsAt({ commit }, fields) {
      commit('getPlanTrialStartsAt', fields);
    },
    getPlanTrialEndsAt({ commit }, fields) {
      commit('getPlanTrialEndsAt', fields);
    },
    getPlanTenantID({ commit }, fields) {
      commit('getPlanTenantID', fields);
    },
    setting({ commit }, fields) {
      commit('setting', fields);
    },
    merchantInfo({ commit }, fields) {
      commit('merchantInfo', fields);
    },
    getPlan({ commit }, fields) {
      commit('getPlan', fields);
    },
    getPlanActive({ commit }, fields) {
      commit('getPlanActive', fields);
    },
    getPlanLastPurchase({ commit }, fields) {
      commit('getPlanLastPurchase', fields);
    },
    getPlanAppMarketing({ commit }, fields) {
      commit('getPlanAppMarketing', fields);
    },
    showPlanNoti({ commit }, fields) {
      commit('showPlanNoti', fields);
    },
    showExceed({ commit }, fields) {
      commit('showExceed', fields);
    },
    flatRates({ commit }, fields) {
      commit('flatRates', fields);
    },
    setMenuWms({ commit }, fields) {
      commit('setMenuWms', fields);
    },
    setUserBookmarks({ commit }, fields) {
      commit('setUserBookmarks', fields);
    },
    unRead({ commit }, fields) {
      commit('unRead', fields);
    },
  };

  // mutations
  const mutations = {
    getUser(state, data) {
      data.bookmarks = JSON.parse(Cookies.get('bookmarks'))
      state.user = data;
      state.user_id = data.id;
    },
    getCurrentUser(state, data) {
      state.currentUser = data;
    },
    updateTotalBalance(state, data) {
      state.totalBalance = data;
    },
    getTenant(state, data) {
      state.tenant = data; 
    },
    getAccess(state, data) {
      state.getAccess = data; 
    },
    getFeature(state, data) {
      state.feature = data;
    },
    getApp(state, data) {
      state.app = data;
    },
    getMenu(state, data) {
      state.menu = data;
    },
    getPackage(state, data) {
      state.package = data;
    },
    getReport(state, data) {
      state.report = data;
    },
    getPlanSerie(state, data) {
      state.planSerie = data;
    },
    getPlanGroup(state, data) {
      state.planGroup = data;
    },
    getPlanTrial(state, data) {
      state.planTrial = data;
    },
    getPlanTrialPeriod(state, data) {
      state.planTrialPeriod = data
    },
    getPlanTrialStartsAt(state, data) {
      state.planTrialStartsAt = data
    },
    getPlanTrialEndsAt(state, data) {
      state.planTrialEndsAt = data
    },
    getPlanTenantID(state, data) {
      state.planTenantID = data
    },
    setting(state, data) {
      state.setting = data;
    },
    merchantInfo(state, data) {
      state.merchantInfo = data;
    },
    getPlan(state, data) {
      state.plan = data;
    },
    getPlanActive(state, data) {
      state.getPlanActive = data;
    },
    getPlanLastPurchase(state, data) {
      state.planLastPurchase = data;
    },
    getPlanAppMarketing(state, data) {
      state.planAppMarketing = data;
    },
    showPlanNoti(state, data) {
      state.showPlanNoti = data;
    },
    showExceed(state, data) {
      state.showExceed = data;
    },
    flatRates(state, data) {
      state.flatRates = data;
    },
    setMenuWms(state, data) {
      state.setMenuWms = data;
    },
    setUserBookmarks(state, data) {
      state.user.bookmarks = data;
      Cookies.set('bookmarks', JSON.stringify(data), { domain: '.' + process.env.CENTRAL_API_ROOT });
    },
    unRead(state, data) {
      state.unRead = data;
    },
  };

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };



// WEBPACK FOOTER //
// ./src/store/modules/user.js